<template>
  <div class="inner">
    <!-- eg: 狂暴之力预售券限时销售-->
    <div class="e4table1"><span class="sping">商品<img
          class="bax"
          src="../../assets/img/bax.png"
          alt=""
        ><b class="bb">{{saleTimeData.num}}</b></span></div>
    <div class="e4table2">
      <div class="conmmp">
        <p class="tit1">{{saleTimeData.title}}<span class="tit2">限时销售</span></p>
        <p>活动时间：<span class="tit2 text2">{{saleTimeData.saleDate}}</span></p>
        <p
          class="textLeft"
          v-for="(item,index) in saleTimeData.p"
          :key="index"
          v-html="item"
        ></p>
      </div>
    </div>
    <div class="e4table3"></div>
  </div>
</template>

<script>
export default {
  name: "saleTime",
  props: ["saleTimeData"],
  data(){
    return {
      saleTime:'saleTime_data'
    }
  },
  created(){
  //  this.saleTimeFn1();
        

  },
  mounted(){

  },
  methods:{
    saleTimeFn1(){
      // console.log(this.test.a)
      // this.test.a='gai'
    }
  }
  
  
};
</script>

<style lang="scss" scoped>
.e4table1 {
  width: 100%;
  height: 140px;
  background: url("../../assets/img/table1.png") no-repeat center top;
  font-size: 34px;
  color: #2d2a2a;
  font-weight: bold;
  text-align: center;
  line-height: 62px;
  position: relative;
  span {
    display: block;
    padding-top: 30px;
    height: 62px;
  }
  span.sping {
    margin-left: -83px;
    .bax {
      position: absolute;
      top: 15px;
      margin-left: 5px;
    }
    .bb {
      position: absolute;
      top: 33px;
      left: 633px;
      font-size: 30px;
    }
  }
}
.e4table2 {
  width: 100%;
  background: url("../../assets/img/table2.png") repeat-y center;
  font-size: 16px;
  position: relative;
  overflow: hidden;
  .conmmp {
    padding: 0 150px;
    text-align: center;
    p {
      margin-bottom: 8px;
      .tit2 {
        color: #ec1111;
      }
    }
    p.tit1 {
      font-size: 32px;
      font-weight: 700;
    }
    p.textLeft {
      text-align: left;
      span {
        color: #ec1111;
      }
    }
  }
}
.e4table3 {
  width: 100%;
  height: 22px;
  background: url("../../assets/img/table3.png") no-repeat center bottom;
}
</style>




























// WEBPACK FOOTER //
// src/components/e1_module/saleTime.vue